export default __webpack_public_path__ + "a25546903854cf34eaa15b67558057dc.svg";